import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { EmployeeDataDefaultProps } from '../EmployeeDataPropTypes';
import { EMPLOYEE_DATA_ACTIONS } from '../actions/EmployeeDataActions';

const initialState = () => ({
    currentRecord: { ...EmployeeDataDefaultProps },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        
        case EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_RESET: {
            return {
                ...state,
                currentRecord: { ...EmployeeDataDefaultProps },
            };
        }

        default:
            return state;
    }
};
